import React from 'react';
import Search from "../Search/Search";
import Layer from "../QuyHoach/Layer";
import MapMode from "../Menu/MapMode";
import Menu from "../Menu/Menu";
import Location from "../Menu/Location";
import LocationEnter from "../Menu/LocationEnter";
import ZonePanel from "../QuyHoach/ZonePanel";
import Result from "../Search/Result";
import Info from "../HienTrang/Info";
import Account from "../Profile/Account";

const ContentRightPanel = ({ route }) => {
    switch (route) {
        case "menu":
            return (
                <Menu />
            );
        case "search":
            return (
                <Search />
            );
        case "layer":
            return (
                <Layer />
            );
        case "satellite":
            return (
                <MapMode />
            );
        case "location":
            return (
                <Location />
            );
        case "locationEnter":
            return (
                <LocationEnter />
            );
        case "zone":
            return (
                <ZonePanel />
            );
        case "result":
            return (
                <Result />
            );
        case "info":
            return (
                <Info />
            );
        case "account":
            return (
                <Account />
            );
        default:
            return null
    }
}

export default ContentRightPanel
